module.exports = __webpack_public_path__ + "static/media/Desktop1.30a1e728.jpg";